export enum AppEventNames {
  LOGOUT = "LOGOUT",
}
export type AppEvents = {
  [AppEventNames.LOGOUT]: [];
};
